import debounce from '../util/debounce';
const SameSizedCards = {
    init() {
        $(window).on('resize', debounce($.proxy(this._onWindowResize, this), 300))
        this._jsCardsContainer = $('.jsSameHeightContainer');
        this._resizeContainers();
    },
    _onWindowResize() {
        this._resizeContainers();
    },
    _resizeContainers() {
        for (let i = 0; i < this._jsCardsContainer.length; i++) {
            if ($(this._jsCardsContainer[i]).data('skip-resize-mobile') == true && window.innerWidth < 768) {
                const jsCards = $(this._jsCardsContainer[i]).find('.jsCard');
                let jCurCard;
                for (let i = 0; i < jsCards.length; i++) {
                    jCurCard = $(jsCards[i]);
                    jCurCard.css('min-height', '');
                }
                continue;
            }
            this._resizeCards($(this._jsCardsContainer[i]).find('.jsCard'));
        }

    },
    _resizeCards(jsCards) {
        let maxHeight = 0; //this._jsCards.innerHeight();
        let jCurCard;
        for (let i = 0; i < jsCards.length; i++) {
            jCurCard = $(jsCards[i]);
            if (jCurCard.innerHeight() > maxHeight) {
                jCurCard.css('min-height', '');
                maxHeight = jCurCard.innerHeight();
            }
        }
        jsCards.css('min-height', maxHeight);
    },

}
export default SameSizedCards;


// WEBPACK FOOTER //
// ./scripts/modules/same_sized_cards.js